// Solaríe — Mobile Banner Swap + Click Link
(function() {
  var MOBILE_IMAGES = [
    'https://cdn.shopify.com/s/files/1/0735/2359/3448/files/solarie_banner_mobile_slide1.png',
    'https://cdn.shopify.com/s/files/1/0735/2359/3448/files/solarie_banner_mobile_slide2.png'
  ];

  var BANNER_LINK = '/collections/all';

  function swapMobileImages() {
    if (window.innerWidth > 749) return;
    var slides = document.querySelectorAll('.slideshow__slide');
    slides.forEach(function(slide, index) {
      if (!MOBILE_IMAGES[index]) return;
      var img = slide.querySelector('.slideshow__media img');
      if (!img) return;
      if (img.dataset.mobileSwapped) return;
      img.src = MOBILE_IMAGES[index];
      img.srcset = MOBILE_IMAGES[index];
      img.sizes = '100vw';
      img.style.objectPosition = 'center top';
      img.dataset.mobileSwapped = 'true';
    });
  }

  function addBannerLinks() {
    var slides = document.querySelectorAll('.slideshow__slide');
    slides.forEach(function(slide) {
      if (slide.dataset.linked) return;
      slide.style.cursor = 'pointer';
      slide.addEventListener('click', function(e) {
        // Only navigate if not clicking a button
        if (e.target.closest('.slider-button, .slideshow__autoplay, .slider-counter__link')) return;
        window.location.href = BANNER_LINK;
      });
      slide.dataset.linked = 'true';
    });
  }

  function init() {
    swapMobileImages();
    addBannerLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(init, 500);
  setTimeout(init, 1500);
})();
